import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { eventBus } from '@atc/cai-event-bus';

import {
    WALLET_ENSURE_PAYMENTS_INFO_COMPLETED,
    WALLET_UPDATE_DATA_AFTER_LOGIN_REQUEST,
    WALLET_GET_INITIALIZATION_STATUS_REQUEST,
    WALLET_GET_INITIALIZATION_STATUS_COMPLETED,
    WALLET_ENSURE_PAYMENTS_INFO_REQUEST,
} from 'wallet-manager';

const AUTH_SIGNIN_COMPLETE = 'auth.signin';

export default function useWalletInitialization({ paymentsDuck, onComplete = () => {} }) {
    const dispatch = useDispatch();

    function handleCompareLoggedInWalletData() {
        eventBus.emit(WALLET_UPDATE_DATA_AFTER_LOGIN_REQUEST);
    }

    const handleWalletInitialization = ({ paymentInfo } = {}) => {
        onComplete(paymentInfo);
        dispatch(paymentsDuck.creators.ensurePaymentsInfo());
    };

    const handleInitializationStatusComplete = ({ isInitialized } = {}) => {
        if (isInitialized) {
            eventBus.emit(WALLET_ENSURE_PAYMENTS_INFO_REQUEST);
        }
    };

    useEffect(() => {
        eventBus.on(WALLET_ENSURE_PAYMENTS_INFO_COMPLETED, handleWalletInitialization);

        return () => {
            eventBus.off(WALLET_ENSURE_PAYMENTS_INFO_COMPLETED, handleWalletInitialization);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Request wallet initialization status when the hook first loads
    useEffect(() => {
        eventBus.emit(WALLET_GET_INITIALIZATION_STATUS_REQUEST);
    }, []);

    useEffect(() => {
        eventBus.on(WALLET_GET_INITIALIZATION_STATUS_COMPLETED, handleInitializationStatusComplete);

        return () => {
            eventBus.off(WALLET_GET_INITIALIZATION_STATUS_COMPLETED, handleInitializationStatusComplete);
        };
    }, []);

    useEffect(() => {
        eventBus.on(AUTH_SIGNIN_COMPLETE, handleCompareLoggedInWalletData);

        return () => {
            eventBus.off(AUTH_SIGNIN_COMPLETE, handleCompareLoggedInWalletData);
        };
    }, []);

    return null;
}
